var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPencilSolid = function SvgPencilSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.156 10.906-7.281 7.281-1.062-1.062.125-.125H7.5a.494.494 0 0 1-.5-.5v-1.438l-.125.126c-.156.156-.25.312-.312.53l-.72 2.438 2.438-.718c.188-.063.375-.157.532-.313l1.062 1.063a2.722 2.722 0 0 1-1.156.687l-3.781 1.094a.638.638 0 0 1-.72-.188.708.708 0 0 1-.218-.718l1.125-3.782c.125-.437.375-.844.688-1.156l7.28-7.281 4.063 4.062Zm2.219-5.062a2.018 2.018 0 0 1 0 2.843l-1.5 1.5-4.063-4.062 1.5-1.5a2.018 2.018 0 0 1 2.844 0l1.219 1.219Z"
  })));
};

export default SvgPencilSolid;